export default "__VITE_ASSET__4287e28e__"